/**
 * Phone number formatting utilities for consistent phone number handling
 */

// Phone number formatting for display (XXX) XXX-XXXX
export const formatPhoneNumber = (value: string): string => {
  if (!value) return "";
  
  // Remove all non-digits
  const cleaned = value.replace(/\D/g, '');
  
  // Format as (XXX) XXX-XXXX
  if (cleaned.length >= 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
  } else if (cleaned.length >= 6) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length >= 3) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
  } else if (cleaned.length > 0) {
    return `(${cleaned}`;
  }
  
  return cleaned;
};

// Extract digits only for storage
export const extractPhoneDigits = (value: string): string => {
  if (!value) return "";
  return value.replace(/\D/g, '');
};

// Format stored phone number for display
export const displayPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return "";
  
  // If it's already formatted, return as is
  if (phoneNumber.includes('(') || phoneNumber.includes('-')) {
    return phoneNumber;
  }
  
  // If it's just digits, format it
  return formatPhoneNumber(phoneNumber);
};

// Validate phone number (US format)
export const validatePhoneNumber = (phoneNumber: string): boolean => {
  const digits = extractPhoneDigits(phoneNumber);
  return digits.length === 10;
};